import { useEffect, useState } from 'react';

export const EFB_LOCAL_STORAGE_NAME = 'EFB_LOCAL_STORAGE_NAME';
export const EFB_PREFLIGHT_ACCORDIONS_STATE = 'EFB_PREFLIGHT_ACCORDIONS_STATE';
export const EFB_WHATS_NEW_STATE = 'EFB_WHATS_NEW_STATE';

export const useLocalStorage = (key, initialValue) => {
    const [value, setValue] = useState(() => {
        const storedValue = localStorage.getItem(key);

        return storedValue !== null ? JSON.parse(storedValue) : initialValue;
    });

    useEffect(() => {
        localStorage.setItem(key, JSON.stringify(value));
    }, [key, value]);

    return [value, setValue];
};

export const setLocalStorage = (key, newValue = {}, initialValue = {}) => {
    let value = initialValue;
    try {
        const storedValue = localStorage.getItem(key);

        if (storedValue !== null) {
            const parsed = JSON.parse(storedValue);

            if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
                value = parsed;
            }
        }
    } catch (error) {
        console.warn(`Failed to parse localStorage key "${key}"`, error);
    }

    const updatedValue = {
        ...value,
        ...newValue,
    };

    localStorage.setItem(key, JSON.stringify(updatedValue));

    return updatedValue;
};
